import React from 'react';
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';

function Form() {
    const pathFrontEnd = '/psp-roles/';
    const pathBackEnd = config.endpoints.backend + 'psp/roles/';

    const form = {
        labelTitleEdit: 'Editar Função',
        labelTitleView: 'Visualizar Função',
        labelTitleAdd: 'Nova Função',
        pathView: pathFrontEnd + 'view',
        urlGoBack: pathFrontEnd + 'list',
        endpointGetById: pathBackEnd + 'getById',
        endpointSave: pathBackEnd + 'save',
        validateOnChange: true,
        fields: [
            {
                name: 'psp_area_role_id',
                label: 'Área de Atuação',
                type: 'select',
                columnSize: 6,
                options: [],
                optionsEndpoint: {
                    endpoint: config.endpoints.backend + 'psp/arearoles/getall',
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: true
                }
            },
            {
                name: 'name',
                label: 'Nome da Função',
                type: 'text',
                columnSize: 6,
                validations: {
                    required: true
                }
            }
        ]
    };

    return (
        <CustomFormContainer
            form={form}
            content={<CustomForm form={form} />}
        />
    );
}

export default Form;
